// extracted by mini-css-extract-plugin
export default {"messageRow":"headline_messageRow__2DRE8","message":"headline_message__F7c4D","headlinePicture":"headline_headlinePicture__xQUUn","headlineText":"headline_headlineText__Q6Z92"};